import { css, Theme } from '@emotion/react'

export const wrapper = css`
  min-width: 180px;
`

export const title = (theme: Theme) => css`
  color: ${theme.colors.accent};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
`

export const ul = css`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const li = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 5px;
`

export const itemContent = (theme: Theme) => css`
  color: ${theme.colors.typographyTwo};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`
